import React from "react";

import exampleDrink1 from "../assets/img/examples/drinks/honey_dew_ale_384.jpg";
import exampleDrink2 from "../assets/img/examples/drinks/peroni_gluten_free_384.jpg";
import exampleDrink3 from "../assets/img/examples/drinks/peroni_gran_riserva_384_v2.jpg";
import exampleDrink4 from "../assets/img/examples/drinks/grecanico_chardonnay_384_v2.jpg";
import exampleDrink5 from "../assets/img/examples/drinks/peroni_libera_384.jpg";

import mapItemChoicesToPrices from "../lib/mapItemChoicesToPrices";

const populateItemChoiceItems = (
  itemChoiceItems,
  menuItemChoiceItems,
  resultList
) => {
  if (!itemChoiceItems || !menuItemChoiceItems) return;

  const choiceCount = itemChoiceItems.length;
  itemChoiceItems.forEach((itemChoiceItem) => {
    const { id, qty, itemChoices } = itemChoiceItem;
    const menuItemChoiceItem = menuItemChoiceItems.find((i) => i.id === id);
    if (!menuItemChoiceItem) return;

    const { name, price, menuItemChoices, isIncluded, isAlwaysVisible } = menuItemChoiceItem;

    
    let pushItem = isAlwaysVisible || choiceCount > 1;
    if (!isAlwaysVisible && pushItem && qty === 1 && isIncluded === true) pushItem = false;
    if (!isAlwaysVisible && pushItem && qty === 0 && isIncluded === false) pushItem = false;

    if (pushItem) resultList.push({ name, price, qty });

    populateItemChoices(itemChoices, menuItemChoices, resultList);
  });
};

const populateItemChoices = (itemChoices, menuItemChoices, resultList) => {
  if (!itemChoices || !menuItemChoices) return;

  itemChoices.forEach((itemChoice) => {
    const { id, itemChoiceItems } = itemChoice;
    const menuItemChoice = menuItemChoices.find((i) => i.id === id);
    if (!menuItemChoice) return;
    const { menuItemChoiceItems } = menuItemChoice;
    populateItemChoiceItems(
      itemChoiceItems,
      menuItemChoiceItems,
      resultList
    );
  });
};

export default (props) => {
  const { items } = props;
  let totalPrice = 0;
  return (
    <div className="basket">
      <div className="basket-contents">
        <div className="basket-contents-inner">
          <div className="section-item-title">
            <div className="section-item-title-inner">
              <h3>Your selection so far</h3>
              <p>When you’re ready place your order with a staff member.
              <br />
                <br />
              Fancy a drink or second thoughts on dessert? Order more at any time by asking a staff member
              </p>
            </div>
          </div>
          <div className="customiser-selector">
            {items.map((object) => {
              const { item, qty, itemChoices } = object;
              const { name, menuItemChoices } = item;

              const choiceList = [];
              const price = mapItemChoicesToPrices(
                itemChoices,
                menuItemChoices
              );
              totalPrice += (price * qty);

              populateItemChoices(itemChoices, menuItemChoices, choiceList);
              return (
                <div className="basket-item-selector">
                  <div className="basket-item-selector-inner">
                    <div className="basket-item-selector-header">
                      <div className="basket-item-name">
                        <p>{name}</p>
                      </div>
                      <div className="basket-item-wrapper">
                        <div className="basket-item-wrapper-inner">
                          <button
                            className="item-price minus"
                            onClick={() => props.reduceQuantity(object)}
                          ></button>
                          <span className="item-price value">
                            {(qty * price).toFixed(2)}
                          </span>
                          <button
                            className="item-price plus"
                            onClick={() => props.increaseQuantity(object)}
                          ></button>
                          <span className="item-price quantity">
                            <p>{qty}</p>
                          </span>
                        </div>
                      </div>
                    </div>

                    {choiceList.map((choice) => {
                      const { qty: choiceQty, name } = choice;
                      const qtyDisplay = choiceQty > 0 ? choiceQty : 1;
                      return Array(qtyDisplay)
                        .fill(null)
                        .map(() => {
                          return (
                            <div className="basket-item-selector-detail">
                              <div className="basket-detail-name">
                                <p className={`${choiceQty > 0 ? '' : 'zero-quantity'}`}>- {name}</p>
                              </div>
                              <div className="basket-detail-wrapper">
                                {/* <p className="item-price value">£{(price).toFixed(2)}</p> */}
                                {/* <p className="item-price value">£{(quantity * price).toFixed(2)}</p> */}
                                {/* <p className="item-price quantity">{choiceQty * quantity}</p> */}
                              </div>
                            </div>
                          );
                        });
                    })}
                  </div>
                </div>
              );
            })}
          </div>
          <div className="order-instructions">
            <p>When you’re ready place your order with a staff member.</p>
          </div>
          <div className="basket-total-wrapper">
            <div className="basket-total-inner">
              <p>Order total {totalPrice.toFixed(2)}</p>
            </div>
          </div>
          {/* <div className="item-button-container">
            <div className="item-button-container-inner">
              <button className="menu-item-cta" >Fire up the ovens </button>
            </div>
            <p>(Don’t worry, you can order more anytime)</p>
          </div> */}
        </div>
      </div>
    </div>
  );
};
